module.exports = __webpack_public_path__ + "static/img/china-2-bg.54d7d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-2-bg.png
// module id = 1383
// module chunks = 1